import React, { useState } from 'react';
import styles from './register.module.css';
import { getsessionStorage } from '../../../utils';
import constant from '../../../constant';

const StepFour = ({ onSubmit, prevStep }) => {
    const [state, setState] = useState({
        contact_person: { name: 'contact_person', value: '', error: '', isRequired: true },
        contact_person_designation: { name: 'contact_person_designation', value: '', error: '', isRequired: true },
        email: { name: 'email', value: '', error: '', isRequired: true },
        password: { name: 'password', value: '', type: 'password', error: '', isRequired: true },
        confirm_password: { name: 'confirm_password', value: '', type: 'password', error: '', isRequired: true },

    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState((prevState) => ({
            ...prevState,
            [name]: { ...prevState[name], value, error: '' },
        }));
    };

    const validateForm = () => {
        let isValid = true;

        const updatedState = { ...state };

        // Validate each field
        Object.keys(updatedState).forEach((key) => {
            if (updatedState[key].isRequired && !updatedState[key].value.trim()) {
                updatedState[key].error = `${key.replace('_', ' ')} is required`;
                isValid = false;
            }
        });

        // Check if passwords match
        if (updatedState.password.value !== updatedState.confirm_password.value) {
            updatedState.confirm_password.error = 'Passwords do not match';
            isValid = false;
        }

        setState(updatedState);
        return isValid;
    };
    const togglePasswordVisibility = (name) => {
        setState((prev) => ({
            ...prev,
            [name]: {
                ...prev[name],
                type: prev[name].type === "password" ? "text" : "password",
            },
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (validateForm()) {
            const storage = getsessionStorage(constant.keys.registration_ref);
            const payload = {
                mobile: storage.mobile,
                email: state.email.value,
                password: state.password.value,
                contact_person: state.contact_person.value,
                contact_person_designation: state.contact_person_designation.value,
                ...storage
            };
            onSubmit(payload);
        }
    };

    return (
        <React.Fragment>
            <div className={`${styles['company-box']} card`}>
                <div className="card-body">
                    <h5 className={`${styles['reg-title']}`}>Company Details</h5>
                    <p className={`${styles['reg-text']}`}>
                        Enter your company's details to complete registration.
                    </p>
                    <form onSubmit={handleSubmit}>
                        <div className="my-4 row">
                            <div className="col-md-6">
                                <input
                                    type="text"
                                    id="contactPerson"
                                    className={`${styles['formctm-control']} form-control ${state.contact_person.error ? 'is-invalid' : ''
                                        }`}
                                    placeholder="Contact Person Name"
                                    value={state.contact_person.value}
                                    onChange={e =>
                                        setState(prevState => ({
                                            ...prevState,
                                            contact_person: { ...prevState.contact_person, value: e.target.value },
                                        }))
                                    }
                                />
                                {state.contact_person.error && (
                                    <div className="invalid-feedback">{state.contact_person.error}</div>
                                )}
                            </div>
                            <div className="col-md-6">
                                <input
                                    type="text"
                                    id="contactPersonDesignation"
                                    className={`${styles['formctm-control']} form-control ${state.contact_person_designation.error ? 'is-invalid' : ''
                                        }`}
                                    placeholder="Contact Person Designation"
                                    value={state.contact_person_designation.value}
                                    onChange={e =>
                                        setState(prevState => ({
                                            ...prevState,
                                            contact_person_designation: {
                                                ...prevState.contact_person_designation,
                                                value: e.target.value,
                                            },
                                        }))
                                    }
                                />
                                {state.contact_person_designation.error && (
                                    <div className="invalid-feedback">{state.contact_person_designation.error}</div>
                                )}
                            </div>
                        </div>
                        <div className="my-4">
                            <input
                                type="email"
                                id="email"
                                className={`${styles['formctm-control']} form-control ${state.email.error ? 'is-invalid' : ''}`}
                                placeholder="Enter your Email"
                                name={state.email.name}
                                value={state.email.value}
                                onChange={handleChange}
                            />
                            {state.email.error && (
                                <div className="invalid-feedback">{state.email.error}</div>
                            )}
                        </div>

                        <div className="my-4">
                            <div className="row">
                                <div className="col-6 position-relative">
                                    <input
                                        type={state.password.type}
                                        id="password"
                                        className={`${styles['formctm-control']} form-control ${state.password.error ? 'is-invalid' : ''}`}
                                        placeholder="Enter your password"
                                        name={state.password.name}
                                        value={state.password.value}
                                        onChange={handleChange}
                                    />
                                    <span
                                        className={`${styles['password-icon']}`}
                                        onClick={() => togglePasswordVisibility('password')}
                                        role="button"
                                        aria-label="Toggle Password Visibility"
                                    >
                                        <i
                                            className={`la ${state.password.type === 'password'
                                                ? 'la-eye-slash'
                                                : 'la-eye'
                                                }`}
                                        />
                                    </span>
                                    {state.password.error && (
                                        <div className="invalid-feedback">{state.password.error}</div>
                                    )}
                                </div>

                                <div className="col-6 position-relative">
                                    <input
                                        type={state.confirm_password.type}
                                        id="confirm_password"
                                        className={`${styles['formctm-control']} form-control ${state.confirm_password.error ? 'is-invalid' : ''}`}
                                        placeholder="Confirm your password"
                                        name={state.confirm_password.name}
                                        value={state.confirm_password.value}
                                        onChange={handleChange}
                                    />
                                    <span
                                        className={`${styles['password-icon']}`}
                                        onClick={() => togglePasswordVisibility('confirm_password')}
                                        role="button"
                                        aria-label="Toggle Password Visibility"
                                    >
                                        <i
                                            className={`la ${state.confirm_password.type === 'password'
                                                ? 'la-eye-slash'
                                                : 'la-eye'
                                                }`}
                                        />
                                    </span>
                                    {state.confirm_password.error && (
                                        <div className="invalid-feedback">{state.confirm_password.error}</div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="d-flex">
                            <button
                                type="button"
                                className={`${styles['verify-btn']} w-50 me-1 btn`}
                                onClick={prevStep}
                            >
                                Previous
                            </button>
                            <button
                                type="submit"
                                className={`${styles['send-btn']} w-50 ms-1 btn`}
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </React.Fragment>
    );
};

export default StepFour;
